export default "__VITE_ASSET__3a69ce4d__"